// Funnel tracking: sends events to GA4 (gtag) and Microsoft Clarity, both loaded in index.html.
// Funnel: section_view -> cta_click -> demo_form_open -> demo_form_submit -> generate_lead

type EventParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
  }
}

export function track(event: string, params: EventParams = {}) {
  try {
    window.gtag?.("event", event, params);
    window.clarity?.("event", event);
  } catch {
    // Tracking must never break the page
  }
}
